import { render } from "./phoneLogin.vue?vue&type=template&id=ac241436&scoped=true&ts=true"
import script from "./phoneLogin.vue?vue&type=script&lang=ts"
export * from "./phoneLogin.vue?vue&type=script&lang=ts"

import "./phoneLogin.vue?vue&type=style&index=0&id=ac241436&scoped=true&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac241436"]])

export default __exports__